"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setGDPRCookie = exports.acceptGDPR = exports.updateGDPRViewCount = exports.getGDPRCookie = void 0;

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getGDPRCookie = function getGDPRCookie(req) {
  var cookies = req && req.headers && req.headers.cookie ? new _universalCookie["default"](req.headers.cookie) : new _universalCookie["default"]();
  var gdpr = cookies.get("ftvOption%3Agdpr");
  var display = !(gdpr && (gdpr.accepted || gdpr.count > 2));
  return {
    display: display,
    cookie: gdpr
  };
};

exports.getGDPRCookie = getGDPRCookie;

var updateGDPRViewCount = function updateGDPRViewCount() {
  var cookies = new _universalCookie["default"]();
  var gdpr = cookies.get("ftvOption%3Agdpr");

  if (gdpr) {
    var count = gdpr.count,
        accepted = gdpr.accepted;
    setGDPRCookie({
      count: count + 1,
      date: new Date(),
      accepted: accepted
    });
  } else {
    setGDPRCookie({
      count: 1,
      date: new Date(),
      accepted: false
    });
  }
};

exports.updateGDPRViewCount = updateGDPRViewCount;

var acceptGDPR = function acceptGDPR() {
  var cookies = new _universalCookie["default"]();
  var gdpr = cookies.get("ftvOption%3Agdpr");

  if (gdpr) {
    var count = gdpr.count;
    setGDPRCookie({
      count: count,
      date: new Date(),
      accepted: true
    });
  } else {
    setGDPRCookie({
      count: 1,
      date: new Date(),
      accepted: true
    });
  }
};

exports.acceptGDPR = acceptGDPR;

var setGDPRCookie = function setGDPRCookie(gdpr) {
  var cookies = new _universalCookie["default"]();
  cookies.set("ftvOption%3Agdpr", gdpr);
};

exports.setGDPRCookie = setGDPRCookie;